import { createContext, useContext } from 'react'

const PyrexxOverviewContext = createContext({})

const usePyrexxOverview = () => useContext(PyrexxOverviewContext)

export { PyrexxOverviewContext, usePyrexxOverview }
